import React from 'react';
import { fmtMoney } from '../../utils/money';

// ديناميكي من summary_items (لا بنود ثابتة). صف مجموع في الأسفل.
export default function ProjectSummaryTable({ items }) {
  if (!items?.length) return null;
  const hasOverrun = items.some((i) => i.overrun_amount > 0);
  const sum = (k) => items.reduce((a, i) => a + (Number(i[k]) || 0), 0);

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-title" style={{ marginBottom: 12 }}>ملخّص البنود</div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>م</th>
              <th>البند</th>
              <th>المنفّذ</th>
              <th>السقف</th>
              <th>المستهلَك</th>
              <th>متبقّي البند</th>
              {hasOverrun && <th>تجاوز</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((it, i) => (
              <tr key={`${it.item_type}-${it.region}`}>
                <td>{i + 1}</td>
                <td style={{ fontWeight: 500 }}>
                  {it.name_ar}
                  {it.region === 'inside_riyadh' && <span className="badge badge-low" style={{ marginInlineStart: 6 }}>داخل الرياض</span>}
                  {it.region === 'outside_riyadh' && <span className="badge badge-medium" style={{ marginInlineStart: 6 }}>خارج الرياض</span>}
                  {it.executed_label && <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{it.executed_label}</div>}
                </td>
                <td>{it.executed_label || '—'}</td>
                <td>{it.ceiling_amount ? fmtMoney(it.ceiling_amount) : '—'}</td>
                <td>{fmtMoney(it.used_amount)}</td>
                <td>{fmtMoney(it.remaining_amount)}</td>
                {hasOverrun && (
                  <td>{it.overrun_amount > 0 ? <span style={{ color: 'var(--danger)' }}>{fmtMoney(it.overrun_amount)}</span> : '—'}</td>
                )}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ fontWeight: 700, background: 'var(--surface-alt)' }}>
              <td></td>
              <td>المجموع</td>
              <td></td>
              <td>{fmtMoney(sum('ceiling_amount'))}</td>
              <td>{fmtMoney(sum('used_amount'))}</td>
              <td>{fmtMoney(sum('remaining_amount'))}</td>
              {hasOverrun && <td>{fmtMoney(sum('overrun_amount'))}</td>}
            </tr>
          </tfoot>
        </table>
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 8 }}>
        * «متبقّي البند» محسوب من سقوف البنود، وقد يختلف عن «متبقّي المشروع» في الرأس (المحسوب على التمويل بعد التحويلات والترحيل).
      </div>
    </div>
  );
}
